import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import BreadcrumbsTemplate from "../components/misc/BreadcrumbsTemplate";
import BlogCard from "./adminPanel/blog/components/BlogCard";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBlogs } from "../reduxToolkit/features/adminPanel/blog";
import { mergeBlogList } from "../hooks/mergeBlogList";
import { mergeManagedContent } from "../hooks/mergeManagedContent";
import LoadingBox from "../components/misc/Loading";
import {
  Alert,
  Autocomplete,
  Box,
  createFilterOptions,
  TextField,
} from "@mui/material";
import Seo from "../utils/Seo";
import { PF } from "../config";
import { colors, eyebrowSx, fonts, radii } from "../theme/designTokens";

// Limit options to show in autocomplete
const OPTIONS_LIMIT = 5;
const defaultFilterOptions = createFilterOptions();

const filterOptions = (options, state) => {
  return defaultFilterOptions(options, state).slice(0, OPTIONS_LIMIT);
};

export default function Blog() {
  const dispatch = useDispatch();
  const [loadingMain, setLoadingMain] = useState(false);
  const [blogList, setBlogList] = useState([]);
  const [blogListEn, setBlogListEn] = useState([]);
  const [searchingBlogList, setSearchingBlogList] = useState([]);

  const [lang, setLang] = useState("en");
  const [langId, setLangId] = useState("");
  const [contentSettings, setContentSettings] = useState([]);

  const [viewMode, setViewMode] = useState([]);

  // store
  const { langs } = useSelector((state) => state.misc);
  const { blogs } = useSelector((state) => state.blog);
  const { activeLangFront } = useSelector((state) => state.miscFront);
  const { webSettings } = useSelector((state) => state.webSettings);
  const { managedContentSettings } = useSelector(
    (state) => state.managedContentSettings
  );

  // Functions
  const getLangId = (langCode) => {
    let id = "";
    const L = langs.find((l) => l.langCode === langCode);
    if (L) id = L._id;
    return id;
  };

  const getEnInfo = (detectorId) => {
    let obj = {
      title: "",
    };
    const B = blogListEn.find((b) => b._id === detectorId);
    if (B) obj = { ...B };
    return obj;
  };

  const handleSearch = (e, newValue) => {
    setSearchingBlogList(newValue);
  };

  useEffect(() => {
    setLoadingMain(true);
    dispatch(getBlogs());
    // dispatch(getAdmins());
    setTimeout(() => {
      setLoadingMain(false);
    }, 1000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set Blogs
  useEffect(() => {
    if (blogs && blogs.length > 0) {
      const enLangId = getLangId("en");
      const B = mergeBlogList(blogs, langId, enLangId);
      setBlogList(B);
      const BEn = blogs.filter((b) => b.langId === enLangId);
      if (BEn) setBlogListEn(BEn);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blogs, langId]);

  // Set Language
  useEffect(() => {
    if (activeLangFront) {
      setLang(activeLangFront.langCode);
      setLangId(activeLangFront._id);
    }
  }, [activeLangFront]);

  const scroll = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Set Blogs
  useEffect(() => {
    // dispatch(getBlogs());
    setTimeout(() => {
      scroll();
    }, 250);
  }, []);

  // Set Language
  useEffect(() => {
    if (activeLangFront) setLang(activeLangFront.langCode);
  }, [activeLangFront]);

  // Set Settings
  useEffect(() => {
    if (managedContentSettings && managedContentSettings.length > 0) {
      const M = mergeManagedContent(managedContentSettings, langId, langs);
      if (M) setContentSettings(M);
    }
  }, [langId, managedContentSettings]);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  return (
    <>
      <Seo
        title={
          (contentSettings.siteSeoSettings &&
            contentSettings.siteSeoSettings[1] &&
            contentSettings.siteSeoSettings[1].siteName) ||
          "Blog | Elifesaving Medicine"
        }
        description={
          (contentSettings.siteSeoSettings &&
            contentSettings.siteSeoSettings[1] &&
            contentSettings.siteSeoSettings[1].siteDesc) ||
          "Blog - Elifesaving Medicine ... H# DCC1, Momin Shoroni Road, North Ibrahimpur, Mirpur-14, Dhaka- 1206, Bangladesh;"
        }
        name={
          (contentSettings.siteSeoSettings &&
            contentSettings.siteSeoSettings[1] &&
            contentSettings.siteSeoSettings[1].companyName) ||
          "Elifesaving Medicine"
        }
        type="website"
        url={window.location.href || ""}
        imageUrl={
          webSettings.siteLogo !== ""
            ? PF + "/misc/" + webSettings.siteLogo
            : "https://mfw.com.bd/wp-content/uploads/2021/05/getImage.png"
        }
        langCode={lang}
      />
      <BreadcrumbsTemplate b3={translateFront("Blog")} sx={{ mx: 0 }} />
      {loadingMain ? (
        <LoadingBox w={"100%"} />
      ) : (
        <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3 }, pb: 6 }}>
          <Box sx={{ textAlign: "center", py: { xs: 3, md: 4 } }}>
            <Box sx={{ ...eyebrowSx, mx: "auto", width: "fit-content" }}>
              Our Blog
            </Box>
            <Typography
              sx={{
                fontFamily: fonts.display,
                fontWeight: 800,
                fontSize: { xs: "1.7rem", md: "2.1rem" },
                color: colors.ink,
                mt: 1.5,
              }}
            >
              {translateFront("Blog")}
            </Typography>
          </Box>

          <Autocomplete
            multiple
            onChange={(e, newValue) => handleSearch(e, newValue)}
            disablePortal
            options={blogList}
            filterOptions={filterOptions}
            getOptionLabel={(option) =>
              option.title
                ? option.title +
                  (lang !== "en"
                    ? " (" + getEnInfo(option.blogDetectorId).title + ")"
                    : "")
                : option.title
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.title}{" "}
                {lang !== "en"
                  ? " (" + getEnInfo(option.blogDetectorId).title + ")"
                  : ""}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={translateFront("Search Blogs...")}
                size="small"
                fullWidth
              />
            )}
            sx={{
              mb: 4,
              "& .MuiOutlinedInput-root": {
                borderRadius: radii.md,
                bgcolor: colors.paperTint,
                "& fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: `1px solid ${colors.primary}` },
              },
            }}
          />

          <Grid container spacing={3}>
            {blogList.length < 1 ? (
              <Grid item xs={12}>
                <Alert
                  severity="warning"
                  fullWidth
                  sx={{ justifyContent: "center" }}
                >
                  {translateFront("No Blogs...")}
                </Alert>
              </Grid>
            ) : (
              (searchingBlogList.length > 0 ? searchingBlogList : blogList).map(
                (x, i) => (
                  <Grid
                    item
                    key={i}
                    xs={12}
                    md={viewMode.includes(x._id) ? 12 : 6}
                  >
                    <BlogCard
                      x={x}
                      blogListEn={blogListEn}
                      lang={lang}
                      frontEnd={true}
                      setViewMode={setViewMode}
                      viewMode={viewMode}
                    />
                  </Grid>
                )
              )
            )}
          </Grid>
        </Box>
      )}
    </>
  );
}
